import { render, staticRenderFns } from "./MailActivation.vue?vue&type=template&id=3728b5a8"
import script from "./MailActivation.vue?vue&type=script&lang=ts"
export * from "./MailActivation.vue?vue&type=script&lang=ts"
import style0 from "./MailActivation.vue?vue&type=style&index=0&id=3728b5a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports